import { render } from "./FleetApplicationClustersReady.vue?vue&type=template&id=8b13238a&scoped=true"
import script from "./FleetApplicationClustersReady.vue?vue&type=script&lang=js"
export * from "./FleetApplicationClustersReady.vue?vue&type=script&lang=js"

import "./FleetApplicationClustersReady.vue?vue&type=style&index=0&id=8b13238a&lang=scss&scoped=true"

import exportComponent from "../../../../../../Users/onchainengineer/workbench/sourcecode/github_autonomy-cloud/dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b13238a"]])

export default __exports__